import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import PeopleIcon from "@mui/icons-material/People";

const GlobalAudienciaMiniCard = ({ data, globalCardsLoader, helperText }) => {
  return (
    <div className="w-full h-full bg-white border-black border-1 rounded-2xl">
      <div className="h-1/4 flex gap-2 items-center px-2">
        <PeopleIcon className="w-7 sm:w-8 md:w-10 lg:w-12 xl:w-14" />
        <h2 className="sm:text-sm lg:text-xl xl:text-2xl font-medium text-left font-Roboto">
          Audiencia
        </h2>
      </div>
      <div className="h-3/4 flex justify-center p-8">
        {globalCardsLoader ? (
          <CircularProgress color="secondary" />
        ) : (
          <div className="flex flex-col gap-4">
            <h2 className="sm:text-3xl lg:text-4xl xl:text-6xl font-bold font-Roboto">
              {Number(data).toLocaleString()}
            </h2>
            {helperText ? (
              <p className="sm:text-xs xl:text-sm text-center text-gray-400">{helperText}</p>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
};

export default GlobalAudienciaMiniCard;
